import { render } from "./CommissionsSummary.vue?vue&type=template&id=0113d048&ts=true"
import script from "./CommissionsSummary.vue?vue&type=script&lang=ts"
export * from "./CommissionsSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__